<template>
  <div class="yellow-tip__wrapper">
    <CustomSvgIcons
      name="scope" :size="20"
      class="scope-icon"
      :color="'var(--active-100)'"
    />
    <span class="yellow-tip__text body ">{{ aiTipText }}</span>
  </div>
</template>

<script setup lang="ts">
import CustomSvgIcons from '@/components/HelpersComponents/CustomSvgIcons.vue'

const { aiTipText } = defineProps<{
  aiTipText: string;
}>();
</script>

<style scoped>
.yellow-tip__wrapper {
  display: flex;
  width: 100%;
  padding: 8px 12px;
  align-items: center;
  justify-content: center;
  background: var(--yellow-80);
  gap: 4px;
  color: var(--active-100);
  border-radius: 28px;
}


</style>
